module.exports = __webpack_public_path__ + "static/img/scroll.8c464cb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/scroll.png
// module id = d5ii
// module chunks = 0